import {combineReducers} from 'redux-immer';
import {produce} from 'immer';

import {authConstants} from '../../components/contexts/Auth';

import authReducers from '../../components/contexts/Auth/reducer';
import cartReducers from '../../components/contexts/Cart/reducer';
import configReducers from '../../components/contexts/Config/reducer';
import contentReducers from '../../components/contexts/Content/reducer';
import notificationReducers from '../../components/contexts/Notification/reducer';
import orderReducer from '../../components/contexts/Order/reducer';
import searchReducers from '../../components/contexts/Search/reducer';


const appReducers = combineReducers(produce, {
    auth: authReducers,
    cart: cartReducers,
    config: configReducers,
    content: contentReducers,
    notification: notificationReducers,
    order: orderReducer,
    search: searchReducers
});


const rootReducer = (state, action) => {

    if (action.type === authConstants.ACTION_AUTH_LOGOUT) {
        state = undefined;
    }

    return appReducers(state, action);
};


export default rootReducer;
